import { render } from "./tb.vue?vue&type=template&id=e26621dc&scoped=true"
import script from "./tb.vue?vue&type=script&lang=js"
export * from "./tb.vue?vue&type=script&lang=js"

import "./tb.vue?vue&type=style&index=0&id=e26621dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e26621dc"]])

export default __exports__